<template>
  <!------------------------>
  <!-- GLAVNI APP TOOLBAR -->
  <!------------------------>
  <v-app-bar
    app
    flat
    color="primary"
    style="z-index: 1999"
    dark
    class="font-weight-medium"
  >
    <router-link to="/">
      <v-img
        style="max-height: 32px; max-width: 32px"
        :src="
          $store.state.storeClient.client.loginSettings.logoLink.length > 0
            ? $store.state.storeClient.client.loginSettings.logoLink
            : defaultAppLogo
        "
      ></v-img>
    </router-link>
    <v-spacer></v-spacer>
    <router-link to="/">
      <v-toolbar-title>
        {{ $store.state.storeClient.client.basicSettings.fullName }}
      </v-toolbar-title>
    </router-link>
    <v-spacer></v-spacer>
    <v-btn text color="white" fab small @click="signOut">
      <v-icon>mdi-logout</v-icon>
    </v-btn>
  </v-app-bar>
</template>

<script>
import { firebaseApp } from "@/firebase";
export default {
  name: "AppNavigation",
  data() {
    return {
      defaultAppLogo: require("@/assets/defaultAppLogo.png"),
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
  },
  methods: {
    async signOut() {
      await firebaseApp.signOut();
      this.$router.replace("/login");
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: white;
}
a:visited {
  color: white;
}
</style>
